//all custom JS snippets
$(document).ready( function() {
  if( $("#customer_register_link").length ){
    /*
        * Avoid page load via instantclick.
        * This is a Fix to load jQuery calendar on registration page.
        */
    $('#customer_register_link').attr('data-no-instant',"");
  }
  if(typeof(gallery_iframe) != "undefined") {
    $('.product_gallery_nav .gallery-cell img').on('click touchstart', function(event) {
      if($('.mediaWrapper').parents('.gallery-cell.is-selected').length==0) {
        vimeo_player.pause();
      }

      if($('.mediaWrapper').parents('.gallery-cell.is-selected').length > 0 ){
        vimeo_player.getPaused().then(function(paused) {
          if(paused){
            vimeo_player.play();
          }
        }).catch(function(error) {
          console.log('Vimeo pause error');
        });
      }
    });
    $('.product_gallery button.previous').on('click touchstart', function(){
      if($('.mediaWrapper').parents('.gallery-cell.is-selected').length==0){
        vimeo_player.pause();
      }
      if($('.mediaWrapper').parents('.gallery-cell.is-selected').length > 0 ){
        vimeo_player.getPaused().then(function(paused) {
          if(paused){
            vimeo_player.play();
          }
        }).catch(function(error) {
          console.log('Vimeo pause error');
        });
      }
    });
    $('.product_gallery button.next').on('click touchstart', function(){
      if($('.mediaWrapper').parents('.gallery-cell.is-selected').length==0){
        vimeo_player.pause();
      }
      if($('.mediaWrapper').parents('.gallery-cell.is-selected').length > 0 ){
        vimeo_player.getPaused().then(function(paused) {
          if(paused){
            vimeo_player.play();
          }
        }).catch(function(error) {
          console.log('Vimeo pause error');
        });
      }
    });
  }


  /*
  * custom functionality to play/pause Vimeo video when moving out to prev/next slide
  * PYR-268
  */
  var tag = document.createElement('script');
  tag.src = "https://player.vimeo.com/api/player.js";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var gallery_iframe = $('.product_gallery iframe').get(0);
  if(typeof(gallery_iframe) != "undefined") {
      var vimeo_player = new Vimeo.Player(gallery_iframe);
  }


  /*
   * On returns page, get order&email id(if exist in url) and prefill
  */
  urlParams = new URLSearchParams(window.location.search);
  return_orderid = urlParams.get('orderid');
  return_email = urlParams.get('email');
  if(return_orderid) {
      $('.Esc-returns-form [name="order_number"]').val(return_orderid);
  }
  if(return_email) {
      $('.Esc-returns-form [name="email"]').val(decodeURI(return_email));
  }

  $("#checkout").unbind("click").on('click', function() {
      if ($('#agree').is(':checked')) {
          $(this).submit();
      }
      else {
          //alert("You must accept the terms and conditions of sale to continue your order.");
          $('.t-and-c-error').show();
          return false;
      }
  });

  $('#agree').change(function() {
      if(this.checked) {
          $('.t-and-c-error').hide();
      }
  });
  
  // Show the checkout button after the js is active
  $("#checkout").removeClass("hide");

  //returns pages translation starts.
  //translate if sitelang is not english
  if(sitelang != 'en') {
      $('.Esc-returns-container p:contains("To start the")').text( 'In order to start the procedure of return of your order, please indicate below your e-mail and your order number');
      var ord_email = $('.Esc-returns-container p:contains("Ordered by")').text().split(':')[1];
      $('.Esc-returns-container p:contains("Ordered by")').text( 'Command of :'+ ord_email);
      var ord_hash = $('.Esc-returns-container h3:contains("Order")').text().split('#')[1];
      $('.Esc-returns-container h3:contains("Order")').text( 'Command #'+ord_hash);
      var return_hash = $('.Esc-returns-container h4:contains("Return Request")').text().split('#')[1];
      $('.Esc-returns-container h4:contains("Return Request")').text( 'Return request #'+return_hash);
      $('.Esc-returns-container .alert-success').text( "Your return request has been taken into account. We strive to answer you as soon as possible and will inform you by e-mail when it has been processed.");
      $('.Esc-returns-container strong:contains("Oops")').remove();
      $('.Esc-returns-container #errorText:contains("find your order")').text( "We are sorry, we can not find your order. Please check your e-mail and order number.");
      //$('.Esc-returns-container #errorText:contains("days has elapsed")').text( "We have found your order, but it has been more than 14 days since the order date and we can not accept the return of your items. Please contact us for more information.");
      // splitting the returns.days_error_html and adding contact us email to the contact us text.
      var $contactUsTextWithLink = "<a href='https://international-cookware.zendesk.com/hc/fr' target='_blank' class='contact_us'> Translation missing: en.customer.returns.days_error_contact_us_html</a>";
      $('.Esc-returns-container #errorText:contains("days has elapsed")').html( "We have found your order, but it has been more than 14 days since the order date and we can not accept the return of your items. Please contact us for more information." + $contactUsTextWithLink);
      $('.Esc-returns-container .alert-danger:contains("select any products")').text( "You did not choose a product to return");
      $('.Esc-returns-container p strong:contains("Status:")').text( 'Status:');
      if($('.Esc-returns-container p:nth-child(1)').html()) {
          var return_status = $('.Esc-returns-container p:nth-child(1)').html();
          $('.Esc-returns-container p:nth-child(1):contains("Pending")').html(return_status.replace('Pending Approval', 'Waiting'));
          $('.Esc-returns-container p:nth-child(1):contains("Approved")').html(return_status.replace('Approved', 'Approved'));
          $('.Esc-returns-container p:nth-child(1):contains("Rejec")').html(return_status.replace('Rejected', 'Request rejected, thank you for contacting us if you wish to know more.'));

      }
      $('.Esc-returns-container p strong:contains("Requested:")').text( 'Application date:');
      $('.Esc-returns-container p strong:contains("Last Status")').text( 'Last update :');
      $('.Esc-returns-container p strong:contains("Refund Method:")').text( 'Repayment method:');
      if($('.Esc-returns-container p:nth-child(4)').html()) {
          var return_method = $('.Esc-returns-container p:nth-child(4)').html().replace('Refund', 'Refund on your credit card');
          $('.Esc-returns-container p:nth-child(4)').html(return_method);
      }
      $('.Esc-returns-container p strong:contains("Notes:")').text( 'Notes:');
      $('.Esc-returns-form label[for="email"]').text( 'Your email :');
      $('.Esc-returns-form #email').attr('placeholder', 'Your email :');
      $('.Esc-returns-form label[for="order_number"]').text( 'Your order number:');
      $('.Esc-returns-form #order_number').attr('placeholder', 'Your order number:');
      $('.Esc-returns-form .btn-primary').text( 'Validate');
      $('.Esc-returns-table th').first().text( 'Product');
      $('.Esc-returns-table th:nth-child(2)').text( 'Amount');
      $('.Esc-returns-table th:nth-child(3)').text( 'Premise');

      $('#step_one h4').text( 'Select the product and quantity to return.');
      $('#step_two h4').text( 'Choose the reason for your return for each item');
      $('#step_three h4').text( 'Finalize your return request');
      $('.Esc-returns-container h4:contains("Submit a")').text( "Return my articles");
      $('.Esc-returns-container #next_step').text( "Carry on");

      $('.Esc-returns-grid label[for="notes"]').text('Notes:');
      $('.Esc-returns-grid label[for="notification_email"]').text('E-mail notification:');
      $('.Esc-returns-grid #passwordHelpBlock').text('You will receive on this e-mail the notifications relating to your return.');
      $('.Esc-returns-grid br').remove();
  }
  //returns pages translation ends.

  $('#lang_modal').unbind("click touchstart").on('click touchstart', function(e){
      $('[data-remodal-id=lang_modal]').remodal().open();
  });

  $(".country_select_wrapper").unbind("click").on('click', function(e) {
      console.log("Toggling country_select_wrapper");
      if($('.country_select_wrapper .language_list').hasClass('active')) {
          $('.country_select_wrapper .language_list').removeClass('active');
      } else {
          $('.country_select_wrapper .language_list').addClass('active');
      }
  });

  //Removes an item from the cart
  //function removeItem(lineid){
  //    $.post('/cart/change.js', {quantity: 0, line: lineid}).done(function( data ) {
  //        location.reload();
  //    });
  //}

  if ($(window).width() >= 798) {
      var arrowSize = {
          x0: 10,
          x1: 60, y1: 50,
          x2: 60, y2: 45,
          x3: 15
      };
      $('.js-collections-slider').flickity({
          //"lazyLoad": 2,
          "imagesLoaded": true,
          "draggable": true,
          "prevNextButtons": true,
          "wrapAround": true,
          "cellAlign": "center",
          "pageDots": true,
          "contain": true,
          groupCells: 3,
          setGallerySize: false,
          "freeScroll": true,
          "arrowShape": arrowSize,
          //"initialIndex": 1
      });
  } else {
      $('.js-collections-slider').flickity({
          "lazyLoad": 2,
          "imagesLoaded": true,
          "draggable": true,
          "prevNextButtons": false,
          "wrapAround": true,
          "cellAlign": "center",
          "pageDots": true,
          "contain": true,
          "freeScroll": false
      });
  }

  $('.js-collections-slider').addClass('slider-initialized');

  if ($(window).width() < 768) {

      $('.grid-slide').addClass('mobile-grid-slider');
      $('.mobile-grid-slider').flickity({
          "lazyLoad": 2,
          "imagesLoaded": true,
          "draggable": true,
          "prevNextButtons": false,
          "wrapAround": true,
          "cellAlign": "center",
          "pageDots": true,
          "contain": true,
          setGallerySize: false,
          "freeScroll": false
      });
  }

});

/* $('html').on('click', function(event) {
    console.log(event.target);
    if(!$(event.target).length && $('.language_list').hasClass('active') ) {
        $('.language_list').removeClass('active');
    }
}); */

 
/* fallback code for URLSearchParams not detecting in ie */
(function (w) {

    w.URLSearchParams = w.URLSearchParams || function (searchString) {
      
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        };
    }

})(window);